import { Form, Loader, Logo, Menu, Modal, Register, SignIn } from 'components'
import { LoginProvider } from '../../contexts'
import { useLogin } from 'hooks'

import styles from './Login.module.scss'
import { Banner, Tab, Tabs, Text } from '@plurall/elo-beta'
import CardContentContainer from '../../components/CardContentContainer/CardContentContainer'

const LoginView = () => {
  const {
    loading,
    user,
    modalOpen,
    handleCloseModal,
    error,
    clearError,
    handleRegisterOptionClick,
    handleOpenModal,
  } = useLogin()

  if (loading) {
    return <Loader />
  }

  if (user) {
    return <SignIn {...user} />
  }

  return (
    <div className={styles.container}>
      <div className={styles.login}>
        <Logo />

        <CardContentContainer>
          <Tabs baseLine>
            <Tab label='Login'>
              <div className={styles['mobile-content']}>
                <Text size='t3' shy>
                  Preencha seus dados de acesso para entrar
                </Text>

                {error && (
                  <div className={styles['error-message']}>
                    <Banner title={error} variant='negative' onClose={clearError} />
                  </div>
                )}

                <Form />
              </div>
            </Tab>
            <Tab label='Cadastro'>
              <div className={styles['mobile-content']}>
                <Text size='t3' shy>
                  Selecione uma opção para se cadastrar
                </Text>

                <div className={styles['register-control-group']}>
                  <Register
                    handleRegisterOptionClick={handleRegisterOptionClick}
                    handleOpenModal={handleOpenModal}
                  />
                </div>
              </div>
            </Tab>
          </Tabs>
        </CardContentContainer>
      </div>

      <Menu />

      {modalOpen && <Modal onClose={handleCloseModal} />}
    </div>
  )
}

const Login = () => (
  <LoginProvider>
    <LoginView />
  </LoginProvider>
)

export default Login
